import React, { ReactNode } from 'react'

import './index.less'

interface CommonPlaceholderProps {
  title: string
  content: string | ReactNode
  danger?: boolean
}

export const CommonPlaceholder = ({ title, content, danger }: CommonPlaceholderProps): JSX.Element => {
  return (
    <div className={`CommonPlaceholder ${danger ? 'danger' : ''}`}>
      <div className="CommonPlaceholder__container">
        <h6>{title}</h6>
        {typeof content === 'string' ? <p>{content}</p> : <>{content}</>}
      </div>
    </div>
  )
}
